import Vue from '../consts/vue'
import http from './http'

Vue.prototype.$http = http
